// Port of api/fuel/app/classes/filter/search/games/filters/query/play/duration.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'play.duration',
	priority: 62,
	require: function(config, filter) { return filter.play && rangeActive(filter.play.duration, 0, 360) },
	run: function(config, filter, data, query) {
		if (filter.play.duration.from > 0) query.where('p.play_length', '>=', filter.play.duration.from)
		if (filter.play.duration.to < 360) query.where('p.play_length', '<=', filter.play.duration.to)
	}
}
